import loadable from '@loadable/component';

export const MusicweekSiteWrapper = loadable(
  () => import(/* webpackChunkName: "musicweek-site" */ './MusicweekSiteWrapper'),
);
